// src/utils/auth.js
const USER_KEY = "tt_user";
const GUEST_KEY = "tt_guest_id";

export function ensureGuestId() {
  let id = localStorage.getItem(GUEST_KEY);
  if (!id) {
    id = crypto?.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random();
    localStorage.setItem(GUEST_KEY, id);
  }
  return id;
}

export function getUser() {
  try { return JSON.parse(localStorage.getItem(USER_KEY)) || null; } catch { return null; }
}

export function isLoggedIn() { return !!getUser(); }

export function loginWithEmail(email) {
  const user = { email, createdAt: Date.now(), guestId: ensureGuestId() };
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  return user;
}

export function logout() { localStorage.removeItem(USER_KEY); }
